export class Offcanvas {
  constructor() {
    this.offcanvas = document.querySelector('[data-offcanvas]');
    if (this.offcanvas === null) {
      return;
    }
    this.openTriggers = this.offcanvas.querySelectorAll('[data-offcanvas-open]');
    this.closeTriggers = this.offcanvas.querySelectorAll('[data-offcanvas-close]');
    this.submenus = this.offcanvas.querySelectorAll('[data-offcanvas-submenu]');
    this.activeClass = 'is-active';
    this.init();
  }

  init() {
    this.addEventListeners();
  }

  addEventListeners() {
    this.openTriggers.forEach((trigger) => {
      const key = trigger.dataset.offcanvasOpen;
      const submenu = this.offcanvas.querySelector('[data-offcanvas-submenu="' + key + '"]');
      trigger.addEventListener('click', () => {
        this.openSubmenu(submenu);
      });
    });
    this.closeTriggers.forEach((trigger) => {
      const key = trigger.dataset.offcanvasClose;
      const submenu = this.offcanvas.querySelector('[data-offcanvas-submenu="' + key + '"]');
      trigger.addEventListener('click', () => {
        this.closeSubmenu(submenu);
      });
    });
    this.offcanvas.addEventListener('closeOverlay', (e) => {
      if (e.detail.key === 'offcanvas') {
        this.reset();
      }
    });
  }

  openSubmenu(submenu) {
    submenu.classList.add(this.activeClass);
  }

  closeSubmenu(submenu) {
    submenu.classList.remove(this.activeClass);
  }

  reset() {
    this.submenus.forEach((submenu) => {
      this.closeSubmenu(submenu);
    });
  }

}
document.addEventListener("DOMContentLoaded", function() {
  new Offcanvas();
});
